import { useEffect, useState, useCallback } from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import NoHistory from "@features/mindfulness/NoHistory";
import { getQuizHistory } from "api/quizGame";
import { CircularProgress } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import { quizTypesData } from "data/uiData/quizTypes";
import { placesSliderData, sliderData } from "data/uiData/RanksData";
import {
  QuestionAnswered,
  CorrectAnswer,
  Accuracy,
  Points,
} from "@utils/defaultImages";

const PastQuizes = () => {
  const [quizHistory, setQuizHistory] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const fetchQuizHistory = useCallback(async (page = 1, isNewLoad = false) => {
    try {
      const response = await getQuizHistory({ page });

      if (response && response.quiz_history) {
        const { data, current_page, last_page } = response.quiz_history;

        if (isNewLoad || page === 1) {
          setQuizHistory(data);
        } else {
          setQuizHistory((prev) => [...prev, ...data]);
        }

        // Update pagination state
        setHasMore(current_page < last_page);
        setCurrentPage(current_page + 1);
      }

      setIsInitialLoad(false);
    } catch (error) {
      console.error("Failed to get quiz data:", error);
      setError(error.response?.data?.message || "An error occurred");
      setIsInitialLoad(false);
    }
  }, []);

  // Initial fetch
  useEffect(() => {
    setCurrentPage(1);
    setHasMore(true);
    setQuizHistory([]);
    setIsInitialLoad(true);
    fetchQuizHistory(1, true);
  }, [fetchQuizHistory]);

  // Function called when user scrolls to bottom
  const fetchMoreData = () => {
    if (hasMore) {
      fetchQuizHistory(currentPage);
    }
  };

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "N/A";

      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      };

      return date.toLocaleDateString("en-GB", options);
    } catch (error) {
      return "N/A";
    }
  };

  const nutrientData = {
    answeredQuestion: {
      label: "Questions Answered",
      icon: QuestionAnswered,
      tabColor: "#fff",
    },
    answerCorrect: {
      label: "Correct Answers",
      icon: CorrectAnswer,
      tabColor: "#fff",
    },
    accurate: {
      label: "Accuracy",
      icon: Accuracy,
      tabColor: "#fff",
    },
    pointsEarned: {
      label: "Points",
      icon: Points,
      tabColor: "#fff",
    },
  };

  const Icon =
    quizTypesData?.find((item) => item.label === "Reduce Stress")?.icon ??
    quizTypesData?.[0]?.icon;

  const QuizIcon = sliderData[0]?.RankImage;
  const QuizPlaceIcon = placesSliderData[0]?.RankImage;
  return (
    <div
      className="py-4 px-7 rounded-lg bg-cover from-blue-600 to-blue-500 h-full"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-medium text-white text-lg">
          {t("quizGame.Quiz History")}
        </h2>
      </div>

      {/* Initial loading state */}
      {isInitialLoad ? (
        <div className="text-white text-center py-4">
          <CircularProgress color="white" thickness={7} />
        </div>
      ) : quizHistory?.length > 0 ? (
        <div
          id="scrollable-quiz-container"
          className="max-h-[340px] overflow-y-auto pr-2 custom-scrollbar"
        >
          <InfiniteScroll
            dataLength={quizHistory.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <div className="text-white text-center py-4">
                <CircularProgress color="white" thickness={7} size={24} />
              </div>
            }
            endMessage={
              <div className="text-white/70 text-center py-2 text-sm">
                {t("quizGame.All quiz history loaded")}
              </div>
            }
            scrollableTarget="scrollable-quiz-container"
            className="space-y-3"
          >
            {/* <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
              {[1, 2].map((item) => {
                return (
                  <div className="bg-white rounded-2xl p-4 relative mt-6">
                    <div className="absolute bottom-[100px] z-10 border border-[#FF8B38] bg-[#FFF6F0] w-[77px] h-[77px] flex items-center justify-center rounded-full">
                      <Icon className="w-10 h-10" />
                    </div>
                    <div className="pl-[90px] pb-[20px]">
                      <div className="flex items-center justify-between">
                        <div className="flex flex-col">
                          <p className="text-[12px] text-[#767676] font-[Lato]">
                            {t("mindfulnessCoachPreferences.Date")}: July 15,
                            2025
                          </p>

                          <h4 className="text-[14px] font-[Lato] font-[400] font-normal">
                         
                            Reduce Stress
                          </h4>
                        </div>
                        <div className="flex items-center gap-2">
                          <img src={QuizPlaceIcon} className="max-w-[90px]" />
                          <img src={QuizIcon} className="w-10 h-10" />
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="flex items-center gap-2 bg-[#FFF0FB]  px-2 py-1 rounded-full">
                        <div className="w-6 h-6 flex items-center justify-center">
                          <QuestionAnswered className="w-4 h-4" />
                        </div>
                        <p className="text-[#FF56DA] text-[14px] font-[600] font-[Lato]">
                          10 Questions Answered
                        </p>
                      </div>
                      <div className="flex items-center gap-2 bg-[#FFF6F0]  px-2 py-1 rounded-full">
                        <div className="w-6 h-6 flex items-center justify-center">
                          <CorrectAnswer className="w-4 h-4" />
                        </div>
                        <p className="text-[#FF8B38] text-[14px] font-[600] font-[Lato]">
                          8 Correct Answers
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 mt-2">
                      <div className="flex items-center gap-2 bg-[#F5FFF0]  px-2 py-1 rounded-full">
                        <div className="w-6 h-6 flex items-center justify-center">
                          <Accuracy className="w-4 h-4" />
                        </div>
                        <p className="text-[#9FFF38] text-[14px] font-[600] font-[Lato]">
                          80% Accuracy
                        </p>
                      </div>
                      <div className="flex items-center gap-2 bg-[#D2FCFF]  px-2 py-1 rounded-full">
                        <div className="w-6 h-6 flex items-center justify-center">
                          <Points className="w-4 h-4" />
                        </div>
                        <p className="text-[#00B7FE] text-[14px] font-[600] font-[Lato]">
                          80 Points
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div> */}

            {quizHistory.map((item, index) => {
              return (
                <div
                  key={`${item?.id}-${index}`}
                  className="bg-white rounded-2xl p-4"
                >
                  <p className="mb-2 text-[12px] text-[#767676] font-[Lato]">
                    {t("mindfulnessCoachPreferences.Date")}:{" "}
                    {formatDate(item?.updated_at)}
                  </p>

                  <div className=" items-center justify-between">
                    <h4 className="text-[14px] font-[Lato] font-[400] font-normal">
                      {/* Quiz #{item?.quiz_id} */}
                      {item?.quiz_title}
                    </h4>
                    <div className="flex items-center gap-2">
                      {/* Accuracy Badge */}
                      {item?.accuracy && (
                        <div className="bg-[#E8F5E8] text-[#4CAF50] text-[12px] font-[600] font-[Lato] px-2 py-1 rounded">
                          {item.accuracy}% {t("quizGame.Accuracy")}
                        </div>
                      )}
                      {/* Points Badge */}
                      <div className="bg-[#D2FCFF] text-[#00B7FE] text-[12px] font-[600] font-[Lato] px-2 py-1 rounded">
                        {item?.point_earned || 0} {t("quizGame.Points")}
                      </div>
                      {item?.badge_unlock &&
                        (item?.badge_unlock?.type === "milestone"
                          ? "🏆"
                          : "🏝️")}
                    </div>
                  </div>
                </div>
              );
            })}
          </InfiniteScroll>
        </div>
      ) : (
        <div className="text-white text-center py-4">
          <NoHistory quizHistory={true} />
        </div>
      )}

      {/* Error message */}
      {/* {error && (
        <div className="text-red-300 text-center py-4">
          {error}
        </div>
      )} */}

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 12px;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background-color: #fff !important;
          border-radius: 10px;
          margin: 4px 0;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(150deg, #0771ef 12.89%, #15aafc 85.22%);
          border-radius: 10px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.3);
        }
      `}</style>
    </div>
  );
};

export default PastQuizes;
